import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function send(data) {
        return axios.post(`${endpoint}/send`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function preview(id, data) {
        return axios.get(`${endpoint}/${id}/preview`, { headers: { Accept: 'text/html' }, params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function approve(id, data) {
        return axios.get(`${endpoint}/${id}/approve`, { headers: { Accept: 'text/html' }, params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function withdrawApproval(id, data) {
        return axios.get(`${endpoint}/${id}/withdraw-approval`, { headers: { Accept: 'text/html' }, params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function cancel(id, data) {
        return axios.get(`${endpoint}/${id}/cancel`, { headers: { Accept: 'text/html' }, params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function continueSending(id, data) {
        return axios.get(`${endpoint}/${id}/continue-sending`, { headers: { Accept: 'text/html' }, params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function test(id, data) {
        return axios.post(`${endpoint}/${id}/test`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function statistic(id) {
        return axios.get(`${endpoint}/${id}/statistic`).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        preview,
        send,
        test,
        approve,
        statistic,
        withdrawApproval,
        cancel,
        continueSending
    }
}

export default service
